<div class="upsell-reviews">
  <div class="upsell-reviews__container mx-auto w-full p-4">

    <div class="upsell-reviews__mainTitle" [innerHTML]="reviewsTitle"></div>
    
    <div class="upsell-reviews__review" *ngFor="let review of reviews">
      <div>
        <div class="upsell-reviews__items py-8">
          <div class="upsell-reviews__stars" *ngIf="review.stars">
            <img class="inline" src="{{ star }}" *ngFor="let stars of Arr(review.stars).fill(0)" />
          </div>
          <div class="upsell-reviews__headline py-4" [innerHTML]="review.headline" *ngIf="review.headline"></div>
          <div class="upsell-reviews__text" [innerHTML]="review.text" *ngIf="review.text"></div>
          <div class="upsell-reviews__author py-4" [innerHTML]="review.author" *ngIf="review.author"></div>
          <div class="upsell-reviews__disclaimer text-xs" [innerHTML]="disclaimer"></div>
        </div>
        <div class="h-px bg-black w-full"></div>
      </div>
    </div>
  </div>
</div>